// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React, {useContext, useState} from 'react';
import {ROUTES} from '@pub/constants.js';
import {get_path, parse_qs} from '@pub/util.js';
import {OAUTH_ACTION} from '@pub/comp/oauth_button';
import {Button} from '@pub/comp/button';
import {Text} from '@pub/comp/text';
import {Form_input, Form_checkbox, PASSWORD_KIND,
    FIELD_KIND} from '@pub/comp/form';
import {Auth_ctx, Email_input, Password_input, Oauth_list} from './common.js';
import {handle_signin} from './handlers.js';
import * as ccns from './common.module.less';

function SI_alts(){
    const [not_registered] = useState(()=>{
        const {login_not_registered} = parse_qs();
        return !!login_not_registered;
    });
    return <div className={ccns.alts}>
      <Text.xxs className={ccns.or} tertiary>or</Text.xxs>
      <Oauth_list action={OAUTH_ACTION.SIGNIN}/>
      {not_registered&&<Text.xxs error className={ccns.oauth_err}>
        Account is not found, please use a Sign up instead
      </Text.xxs>}
    </div>;
}

function Token_2fa(){
    const {token_required} = useContext(Auth_ctx);
    if (token_required!='token_2fa')
        return null;
    return <Form_input id="token_2fa" className={ccns.input} title="2FA token"
      required field="token_2fa" name="token_2fa" kind={FIELD_KIND.TEXT}
      placeholder="012345" is_mono_font auto_focus/>;
}

function Remember_device(){
    return <Form_checkbox id="save_2fa" field="save_2fa"
      name="save_2fa" is_mono_font label="Remember me"/>;
}

function SI_inputs(){
    return <>
      <Email_input/>
      <Password_input password_kind={PASSWORD_KIND.SIGNIN}/>
      <Token_2fa/>
      <Remember_device/>
      <div className={ccns.reset_row}>
        <Button className="sa-reset-link" view="link"
          href={get_path(ROUTES.AUTH_RESET)} size="s">
          Forgot your password?
        </Button>
      </div>
    </>;
}

export const meta = {
    title: 'Log in',
    submit_label: 'Log in',
    form_comp: SI_inputs,
    nav_href: ROUTES.AUTH_SIGNUP,
    nav_label: 'Don\'t have an account? Sign up',
    nav_test_id: 'signup',
    alts: SI_alts,
    on_submit: handle_signin,
};
